/* eslint-disable no-nested-ternary, css-modules/no-unused-class  */

import { FC, useEffect, useState } from 'react';
import { Button, Icon } from 'common-components';
import { ContentType, Tag } from './contentCardTypes';
import { useTranslationContext } from '../contexts/translationContext';
import styles from './contentCard.module.scss';
import Links from './links';

const LeanHover: FC<LeanHoverProps> = (props: LeanHoverProps) => {
    const { type, tags, onContactUsClick, cardUrl, description } = props;
    const [hover, setHover] = useState<boolean>(false);
    const [clicked, setClicked] = useState<boolean>(false);
    const { translate } = useTranslationContext();

    useEffect(() => {
        if (!hover) setClicked(false);
    }, [hover]);

    return (
        <div className={styles['lean-hovered-wrapper']}>
            <div className={styles['hovered-card']}></div>
            <div className={styles['hovered-card-items']}>
                {type === 'lesson' && description && (
                    <div className={styles.description}>
                        <div
                            onClick={() => setClicked(true)}
                            onMouseEnter={() => {
                                setHover(true);
                            }}
                            onMouseLeave={() => {
                                setHover(false);
                            }}
                        >
                            <Icon name="info" />
                        </div>
                        {translate('Description')}
                    </div>
                )}
                {hover && clicked && (
                    <div className={styles['info-box']}>
                        <div className={styles['description-text']}>{description}</div>
                    </div>
                )}
                <img src={`${process.env.PUBLIC_URL}/images/locked.svg`} alt="lockedCard" />
                {type === 'lesson' && <div className={styles['content-lock']}>{translate('contentLock')}</div>}
                {type === 'lesson' && <hr className={styles.divider} />}
                {type === 'lesson' && (
                    <div>
                        {onContactUsClick ? (
                            <Button
                                lowerCase
                                onClick={() => onContactUsClick()}
                                text={translate('IamInterested')}
                                type="flatGray"
                                className={styles['contact-us-button']}
                            />
                        ) : (
                            <div className={styles['lean-disable-text']}>{translate('ContactYourCSM')}</div>
                        )}
                    </div>
                )}
                {type === 'course' && (
                    <a href={cardUrl}>
                        <div className={styles.view}>{translate('ViewCourse')}</div>
                    </a>
                )}
                {type === 'lesson' && (
                    <div className={styles['tags-wrapper']}>
                        <div className={styles.tags}>
                            {tags && tags?.length > 0 && <Icon name="openInNewTab" className={styles.icon} />}
                            {tags && tags?.length > 0 && <Links links={tags} width="17rem" />}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

type LeanHoverProps = {
    type: keyof typeof ContentType;
    onContactUsClick?: Function;
    tags?: Tag[];
    cardUrl?: string;
    description?: string;
};

export default LeanHover;
